import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import type { BrevoFormConfig } from '../data/brevoForms';
import { BrevoResultForm } from './BrevoResultForm';
interface RegistrationModalProps {
  config: BrevoFormConfig;
  onClose: () => void;
  onSuccess: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function RegistrationModal({
  config,
  onClose,
  onSuccess
}: RegistrationModalProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    panelRef.current?.focus();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);
  return <div className="fixed inset-0 z-50 overflow-y-auto bg-noche/85 px-4 py-10" role="dialog" aria-modal="true" aria-label="Registro para recibir tu resultado" data-id="element-129" data-mp="10pq1j7u7uvik">
      <motion.div ref={panelRef} tabIndex={-1} initial={{
      opacity: 0,
      scale: 0.96,
      y: 12
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} className="relative mx-auto w-full max-w-xl bg-hueso p-5 outline-none sm:p-8" data-id="element-130" data-mp="1af9kselucrdy">
        <button type="button" onClick={onClose} aria-label="Cerrar" className="absolute right-3 top-3 rounded-sm p-2 text-noche/45 transition-colors duration-150 ease-out hover:text-violeta focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta" data-id="element-131" data-mp="mpf8pz9cj6ur">
          <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-132" data-mp="226yyy0o3ctbz" />
        </button>

        <p className="font-sans text-sm font-medium tracking-wide text-dorado-deep" data-id="element-133" data-mp="275jzk1799f0y">
          Terminaste el test
        </p>
        <h2 className="mt-2 font-serif text-2xl leading-snug text-violeta sm:text-3xl" data-id="element-134" data-mp="72j43vkfsv5g">
          Tu resultado está listo
        </h2>
        <p className="mt-3 font-sans text-base leading-relaxed text-noche/70" data-id="element-135" data-mp="315urbi4y9ts">
          Déjame tus datos y te lo envío completo a tu correo, junto con el primer paso para empezar
          a subir de nivel hoy mismo.
        </p>

        <div className="mt-6" data-id="element-136" data-mp="c0kja5eqsabn">
          <BrevoResultForm config={config} onSuccess={onSuccess} data-id="element-137" data-mp="3khffj211awgr" />
        </div>
      </motion.div>
    </div>;
}